<script lang="ts">
  import { Reportes } from '../lib/api';

  let indicadores = $state<any | null>(null);
  let egresos = $state<any[]>([]);
  let defunciones = $state<any[]>([]);
  let infecciones = $state<any[]>([]);
  let error = $state<string | null>(null);

  let desde = $state(new Date(Date.now() - 30*24*3600*1000).toISOString().slice(0,10));
  let hasta = $state(new Date().toISOString().slice(0,10));

  async function cargar() {
    try {
      indicadores = await Reportes.indicadores(desde + 'T00:00:00Z', hasta + 'T23:59:59Z');
      egresos = await Reportes.egresos();
      defunciones = await Reportes.defunciones();
      infecciones = await Reportes.infecciones();
    } catch (e:any) { error = e?.message; }
  }
  $effect(() => { cargar(); });
</script>

<section>
  <header><h2>Reportes MSPAS</h2>
    <span><input type="date" bind:value={desde}/> a <input type="date" bind:value={hasta}/> <button onclick={cargar}>Aplicar</button></span>
  </header>
  {#if error}<p class="err">⚠ {error}</p>{/if}

  {#if indicadores}
    <div class="grid">
      <div class="card"><h4>Egresos</h4><p class="big">{indicadores.totalEgresos}</p></div>
      <div class="card"><h4>Estancia promedio</h4><p class="big">{indicadores.promedioEstanciaDias} d</p></div>
      <div class="card"><h4>Defunciones</h4><p class="big">{indicadores.defunciones}</p></div>
      <div class="card"><h4>Tasa mortalidad</h4><p class="big">{indicadores.tasaMortalidadPct} %</p></div>
      <div class="card"><h4>Inf. nosocomiales</h4><p class="big">{indicadores.infeccionesNosocomiales}</p></div>
    </div>
  {/if}

  <h3>Últimos egresos</h3>
  <table>
    <thead><tr><th>Fecha</th><th>Servicio</th><th>Días</th><th>Diagnóstico</th><th>Tipo</th></tr></thead>
    <tbody>
      {#each egresos.slice(0,15) as e (e.id)}<tr><td>{e.fechaEgreso?.slice(0,10)}</td><td>{e.servicio ?? ''}</td><td>{e.diasEstancia}</td><td>{e.diagnosticoPrincipal}</td><td>{e.tipoEgreso}</td></tr>{:else}<tr><td colspan="5" class="empty">Sin egresos.</td></tr>{/each}
    </tbody>
  </table>

  <h3>Defunciones</h3>
  <table>
    <thead><tr><th>Fecha</th><th>Causa básica</th><th>Médico</th></tr></thead>
    <tbody>
      {#each defunciones.slice(0,10) as d (d.id)}<tr><td>{d.fechaDefuncion?.slice(0,10)}</td><td>{d.causaBasica}</td><td>{d.medicoCertificante ?? ''}</td></tr>{:else}<tr><td colspan="3" class="empty">Sin defunciones.</td></tr>{/each}
    </tbody>
  </table>

  <h3>Infecciones nosocomiales</h3>
  <table>
    <thead><tr><th>Fecha</th><th>Tipo</th><th>Agente</th><th>Servicio</th><th>Resuelta</th></tr></thead>
    <tbody>
      {#each infecciones.slice(0,15) as i (i.id)}<tr><td>{i.fechaDiagnostico}</td><td>{i.tipo}</td><td>{i.agente ?? ''}</td><td>{i.servicio ?? ''}</td><td>{i.resuelta ? 'Sí' : 'No'}</td></tr>{:else}<tr><td colspan="5" class="empty">Sin reportes.</td></tr>{/each}
    </tbody>
  </table>
</section>

<style>
  header { display:flex; justify-content:space-between; align-items:center; gap:1rem; flex-wrap:wrap }
  header input { padding:.4rem; border:1px solid #ccc; border-radius:6px }
  header button { padding:.45rem .8rem; border:0; background:#0d6efd; color:#fff; border-radius:8px; cursor:pointer }
  .grid { display:grid; grid-template-columns:repeat(auto-fill,minmax(160px,1fr)); gap:1rem; margin:1rem 0 }
  .card { background:#f5f7fb; border-left:4px solid #234; padding:.8rem 1rem; border-radius:8px }
  .card h4 { margin:0; color:#234; font-size:.85rem; text-transform:uppercase; letter-spacing:.04em }
  .big { margin:.3rem 0 0; font-size:1.8rem; font-weight:700 }
  table { width:100%; border-collapse:collapse; margin-bottom:1rem }
  th, td { padding:.5rem .6rem; border-bottom:1px solid #eee; text-align:left; font-size:.9rem }
  .err { color:#b00020 } .empty { color:#888; text-align:center; font-style:italic }
  h3 { margin-top:1.5rem }
</style>
